import { render, staticRenderFns } from "./CoBrkRefHelplist.vue?vue&type=template&id=7651cd72&"
import script from "./CoBrkRefHelplist.vue?vue&type=script&lang=js&"
export * from "./CoBrkRefHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports